exports.connect = {
	url: "https://api.camping-giens.camp/"
}
